import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { ServerAction } from '../server.action';

type IDependencies = IClientApiDependencySegment;

export const removeServerEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(ServerAction.remove.started),
  mergeMap((params) => {
    const { serverId } = params;

    return dependencies.api.deleteServer({ serverId }).pipe(
      mergeMap(() => {
        return [
          ServerAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          ServerAction.remove.failed({ params, error: null }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
